var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.639 10.583C9.639 11.1723 9.486 11.7277 9.18 12.249C8.88533 12.759 8.44333 13.184 7.854 13.524C7.276 13.8527 6.59033 14.0453 5.797 14.102V15.479H4.709V14.085C3.57567 13.983 2.66333 13.643 1.972 13.065C1.28067 12.4757 0.923667 11.6823 0.901 10.685H3.451C3.519 11.501 3.93833 11.994 4.709 12.164V8.917C3.893 8.713 3.23567 8.509 2.737 8.305C2.23833 8.101 1.80767 7.77233 1.445 7.319C1.08233 6.86567 0.901 6.248 0.901 5.466C0.901 4.48 1.25233 3.67533 1.955 3.052C2.669 2.42867 3.587 2.07167 4.709 1.981V0.603999H5.797V1.981C6.885 2.07167 7.752 2.40033 8.398 2.967C9.05533 3.53367 9.42367 4.31567 9.503 5.313H6.936C6.902 4.98433 6.783 4.701 6.579 4.463C6.38633 4.21367 6.12567 4.038 5.797 3.936V7.149C6.647 7.36433 7.31567 7.574 7.803 7.778C8.30167 7.97067 8.73233 8.29367 9.095 8.747C9.45767 9.189 9.639 9.801 9.639 10.583ZM3.383 5.347C3.383 5.721 3.49633 6.027 3.723 6.265C3.94967 6.49167 4.27833 6.67867 4.709 6.826V3.885C4.301 3.94167 3.978 4.09467 3.74 4.344C3.502 4.59333 3.383 4.92767 3.383 5.347ZM5.797 12.198C6.22767 12.1187 6.562 11.943 6.8 11.671C7.04933 11.399 7.174 11.0703 7.174 10.685C7.174 10.311 7.055 10.0107 6.817 9.784C6.579 9.55733 6.239 9.37033 5.797 9.223V12.198Z",
    fill: "#00C838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.1163782ae47688678a73bd2cec7c747a.svg";
export { ForwardRef as ReactComponent };